import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	total: 0,
	page: 1,
	maxPage: 1,
	fetchedReturns: [],
};

const inwardReturnsSlice = createSlice({
	name: 'inwardReturns',
	initialState: initialState,
	reducers: {
		setInwardReturns: (state, action) => action.payload,
		reset: (state, action) => initialState,
	},
});

export const { setInwardReturns, reset } = inwardReturnsSlice.actions;

export default inwardReturnsSlice.reducer;